import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BlobProvider } from "@react-pdf/renderer";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { PrinterOutlined } from "@ant-design/icons";

import DataTable from "../../../../Components/DataTable";
import * as propertyActions from "../../../../actionCreators/Property";
import PropertyViewPdf from "./PropertyViewPdf";

import "./style/propertyListing.css";
import moment from "moment";

import { addEllipsis } from "../../../../utils";

import { Checkbox, Popconfirm } from "antd";
import PhTenForm from "./Forms/PhTenForm";

const ALLProperties = ({
  properties,
  getProperties,
  getPropertyData,
  paginationData,
  getSelectedRows,
  getCurrentProperty,
}) => {
  const history = useHistory();
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(10);

  React.useEffect(() => {
    if (properties.data) {
      setPagination(properties.pagination);
      setLoading(properties.loading);
      paginationData(properties.pagination);

      const propertiesData = properties.data.map((property) => {
        return { ...property, checked: false };
      });

      setData(propertiesData);
    }
  }, [properties]);

  React.useEffect(() => {
    getSelectedRows(selectedRows);
  }, [selectedRows]);

  const handleTablePageChange = (tableChangeData, filters) => {
    const { current, pageSize } = tableChangeData;
    const status = filters.status;
    setPageSize(pageSize);
    if (status !== null) {
      if (status.length === 1) {
        getProperties({
          page: current - 1,
          pageSize: pageSize,
          type: "unregistered",
          filter: status[0],
        });
      } else {
        getProperties({
          page: current - 1,
          pageSize: pageSize,
          type: "unregistered",
        });
      }
    } else {
      getProperties({
        page: current - 1,
        pageSize: pageSize,
        type: "unregistered",
      });
    }
  };

  const tableColumns = [
    {
      title: "Owner Name",
      dataIndex: "property_owners",
      render: (property_owners) => {
        return addEllipsis(
          property_owners?.map((owner) => owner.name)?.join(",")
        );
      },
    },
    {
      title: "Circle",
      align: "center",
      dataIndex: "circle",
      render: (circle) => (circle ? circle.name : "---"),
    },
    {
      title: "Highway",
      align: "center",
      dataIndex: "highway",
      render: (highway) => (highway ? highway?.name : "---"),
    },
    {
      title: "Address",
      width: "25%",
      dataIndex: "address",
      render: (address, record) =>
        record?.plot_number +
        ", " +
        record?.street_address +
        ", " +
        record?.road_name,
    },
    {
      title: "Tax Inspector",
      align: "center",
      dataIndex: "property_inspector",
      render: (property_inspector) =>
        property_inspector ? property_inspector?.user?.full_name : "---",
    },
    {
      title: "PIN",
      dataIndex: "pin",
      width: "10%",
      align: "center",
      render: (pin) => (pin ? pin : "---"),
    },
    {
      title: "Status",
      width: "15%",
      align: "center",
      dataIndex: "status",
      filters: [
        {
          text: "Rejected",
          value: "rejected",
        },
        {
          text: "Awaiting Approval",
          value: "awaiting",
        },
      ],
      // onFilter: (data, row) => {
      //   if (row.approval_status === "rejected" && data === "rejected") {
      //     return true;
      //   } else if (
      //     row.approval_status === null &&
      //     row.submission_type === "submitted" &&
      //     data === "awaiting"
      //   ) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // },
      render: (status, row) => {
        if (row.approval_status === "rejected") {
          return <span style={{ color: "red" }}>Rejected</span>;
        } else if (
          row.approval_status === null &&
          row.submission_type === "submitted"
        ) {
          return "Awaiting Approval";
        } else if (row.approval_status === "approved" && row.pin === null) {
          return "Awaiting PIN";
        } else if (status !== null) {
          return status?.toUpperCase();
        }
      },
    },
  ];

  const onTableRowClickForPhOneForm = (data) => {
    // taxCollectionActions.resetTaxCollection()
    // setRowData(data);
    getCurrentProperty(data);
    history.push("/properties/viewform/" + data.id);
  };
  const onTableRowClick = (data) => {
    getPropertyData(data);
  };

  return (
    <div>
      <DataTable
        rowClassName="table-row-cursor-pointer"
        columns={tableColumns}
        pagination={pagination}
        loading={loading}
        // getSelectedRows={getSelectedRows}
        data={data}
        handleTableValuesChange={handleTablePageChange}
        onRowClick={onTableRowClick}
      />
    </div>
  );
};

const mapStateToProps = ({ property: { properties } }) => ({ properties });

const mapDispatchToProps = (dispatch) => ({
  getProperties: bindActionCreators(propertyActions.getProperties, dispatch),
  getCurrentProperty: bindActionCreators(
    propertyActions.getCurrentProperty,
    dispatch
  ),
});

ALLProperties.propTypes = {
  properties: PropTypes.object.isRequired,
  getProperties: PropTypes.func.isRequired,
  getCurrentProperty: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ALLProperties);
